module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgBdZDBDYJAEEVnBwuxBD0Y9eBhD0bjSTvQCrQDoQK0AkuAmxEOBDkQtAjpwHhnZ53VYCDgP+1O/vx5MxAkt22Y3PfwR0gFCU1kB3H2OEdpt2GYy9FBEW00fyzEKIjSddUgyofpRjZwoSsQ7elk4NQMpS5RarPBMOWcLEUbGKeteZxLpGOEduWmEwU+G4bwmrkGlkDkSiunBmmh5QHoHkcfebudqXe+YNkSEU4aNBQEq4Uc+b87mCsKBO8TSdRfyKFfHdlRhXoJ0M5Mju022jcufVs8B60IuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 0